import React, { Component } from 'react';
import { Steps } from 'antd';
const Step = Steps.Step;

export default class SsStepperSteps extends Component {
    constructor(props) {
        super(props);
    }

    buildSteps() {
        const { id, changeStep } = this.props;
        let result = [], prefix = 'ss-stepper-step-';
        this.props.steps.forEach((s, i) => {
            result.push(
                <Step
                    key={`${id}-${prefix}key-${i}`}
                    title={(
                        <a
                            href='#'
                            id={`${id}-${prefix}${i}`}
                            steptitle={s.title}
                            stepindex={i}
                            onClick={(e) => {
                                let
                                el = document.querySelector(`#${id}-${prefix}${i}`),
                                title = el.getAttribute('steptitle'),
                                index = parseInt(el.getAttribute('stepindex'));
                                changeStep(
                                    typeof title !== 'string' ? null : title,
                                    index.isNaN ? null : index
                                );
                            }}
                        >
                            {s.title}
                        </a>
                    ) || null}
                    description={(
                        <div style={{ textAlign: 'center' }}>
                            {s.description}
                        </div>
                    )}
                    icon={s.icon}
                    status={s.status}
                />
            );
        });
        return (
            <Steps
                progressDot={this.props.progressDot}
                size='small'
                current={this.props.current}
                style={{ width: '100%' }}
            >
                {result}
            </Steps>
        );
    }

    render() {
        return (
            <div>
                {this.buildSteps()}
            </div>
        );
    }
}
